import { render, staticRenderFns } from "./PaymentAffiliatesModal.vue?vue&type=template&id=3b3bfd7d&scoped=true"
import script from "./PaymentAffiliatesModal.vue?vue&type=script&lang=js"
export * from "./PaymentAffiliatesModal.vue?vue&type=script&lang=js"
import style0 from "./PaymentAffiliatesModal.vue?vue&type=style&index=0&id=3b3bfd7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b3bfd7d",
  null
  
)

export default component.exports